import router from '../router'

const routerUtils = {
  moveTo(route: string) {
    router.push({ path: `${route}` })
  }
}

export default routerUtils